var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',_vm._l((_vm.cpt_names),function({name, args}){return _c(name,{key:name,ref:"cpt",refInFor:true,tag:"component",attrs:{"args":args}})}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }